export const WEEKDAYS = {
  ko: ["일", "월", "화", "수", "목", "금", "토"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  es: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
}

export const DETAIL_TEXT = {
  back: { ko: "뒤로", en: "Back", es: "Volver" },
  selectDate: {
    ko: "날짜를 선택해주세요",
    en: "Select a date.",
    es: "Por favor, seleccione una fecha."
  },
  selectDesc: {
    ko: "해당 일자의 시간대별 상세 그래프를 볼 수 있습니다.",
    en: "You can view the hourly detail chart for that day.",
    es: "Puede ver el gráfico detallado por hora de ese día."
  }
}

const LEAK_START_TIME_FILTER = {
  key: "leakStartTime",
  label: {
    ko: "누수 시작시점",
    en: "Leak Start Time",
    es: "Inicio de fuga"
  }
}

const DATE_FILTERS = [
  { key: "week", label: { ko: "1주일", en: "1W", es: "1S" } },
  { key: "months", label: { ko: "1개월", en: "1M", es: "1M" } },
  { key: "3months", label: { ko: "3개월", en: "3M", es: "3M" } },
  { key: "6months", label: { ko: "6개월", en: "6M", es: "6M" } },
  { key: "years", label: { ko: "1년", en: "1Y", es: "1A" } }
]

export const usageChartBundle = {
  title: {
    ko: "시간당 {resource} 사용량",
    en: "Hourly {resource} Usage",
    es: "Uso horario de {resource}"
  },
  leakStartTimeFilter: LEAK_START_TIME_FILTER,
  dateFilters: DATE_FILTERS,
  filter: {
    periodSettings: { ko: "기간 설정", en: "Period Settings", es: "Configuracion del periodo" },
    startDate: { ko: "시작일", en: "Start Date", es: "Fecha de inicio" },
    endDate: { ko: "종료일", en: "End Date", es: "Fecha de fin" }
  },
  noSelectionMessage: {
    ko: "* 세대를 선택 후 기간을 확인하세요.",
    en: "* Select a unit to view the period.",
    es: "* Seleccione una unidad para ver el periodo."
  },
  customRangeLabel: {
    ko: "직접 설정",
    en: "Custom Range",
    es: "Rango personalizado"
  },
  time: { ko: "시", en: "H", es: "h" },
  search: { ko: "검색", en: "Search", es: "Buscar" },
  info: {
    usage: { ko: "사용량", en: "Usage", es: "Uso" },
    leakAmount: { ko: "누수량", en: "Leak Volume", es: "Volumen de fuga" },
    leakRate: { ko: "누수율", en: "Leak Rate", es: "Tasa de fuga" },
    leakStartTime: { ko: "누수 시작시점", en: "Leak Start Time", es: "Inicio de fuga" },
    leakType: { ko: "누수 유형", en: "Leak Type", es: "Tipo de fuga" },
    period: { ko: "기간", en: "Period", es: "Periodo" }
  }
}

export const usageMetrics = {
  usage: { ko: "사용량", en: "Usage", es: "Uso" },
  leakAmount: {
    ko: "예상 손실량",
    en: "Estimated Loss Volume",
    es: "Volumen estimado de perdida"
  },
  leakRate: { ko: "손실률", en: "Loss Rate", es: "Tasa de perdida" },
  usageBill: { ko: "리소스 요금", en: "Resource Bill", es: "Costo del recurso" },
  leakBill: { ko: "손실 예상 요금", en: "Estimated Loss Cost", es: "Costo estimado de perdida" },
  billRatio: { ko: "요금 대비", en: "Bill Ratio", es: "Relacion de costo" },
  currency: { ko: "원", en: "KRW", es: "KRW" }
}
